<template>
  <div>
    <vx-card>
      <ListProdutos :subjectPermission="subjectPermission"></ListProdutos>
    </vx-card>
  </div>
</template>

<script>
import ListProdutos from "./../../lists/ListProdutos";

export default {
  data() {
    return {
      subjectPermission: "Produto",
    };
  },
  methods: {},
  components: {
    ListProdutos,
  },
};
</script>
